import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "log-out",
  "use": "log-out-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"log-out\"><path d=\"M16 9v6H8v4l-8-7 8-7v4h8zm-6-7v2h12v16H10v2h14V2H10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/log-out.svg
// module id = SABZ
// module chunks = 1